import useDimensions from "react-cool-dimensions";

export default function useSize<T extends HTMLElement>(
  ref: React.MutableRefObject<T>
) {
  const { width, height } = useDimensions({ ref });
  return { width, height };
}
